<template>
	<v-row class="form-items">
		<v-col :cols="12" wrap v-for="(group, indexGroup) in formGroupsList" :key="indexGroup" class="py-0">
			<h4 class="primary--text">{{ group.name }}</h4>
			<v-container>
				<group-item-view
					class="ml-1"
					v-model="formGroupsList[indexGroup].formItemsList"
					:checkBoxUniq="formGroupsList[indexGroup].fogrunic === '1'"
					@eventCheck="handleEventCheck"
				/>
			</v-container>
		</v-col>
	</v-row>
</template>

<script>
import GroupItemView from './GroupItemView.vue';
export default {
	name: 'FormItemsLayout',
	components: {
		'group-item-view': GroupItemView
	},
	props: {
		value: {
			type: Array
		},
		id: {
			type: [String, Number],
			required: true
		}
	},
	data() {
		return { 
			groupCheckbox: {},
			groupCheckboxValue:{} 
		};
	},
	methods: {
		sortOrderAsc(list) {
			return list.sort((a, b) => (a.order < b.order ? -1 : 1));
		},
		handleEventCheck(checkbox, checkboxValue) {
			this.groupCheckbox = { ...this.groupCheckbox, ...checkbox };
			this.groupCheckboxValue = { ...this.groupCheckboxValue, ...checkboxValue };
			this.$emit('formItemsData', this.groupCheckbox, this.groupCheckboxValue);
			this.$emit('checkItemsGroup', this.checkItemsGroup(this.groupCheckbox));
            //this.$emit('checkItemsGroup', this.checkItemsGroup(this.groupCheckbox, this.groupCheckboxValue));
		},
		checkItemsGroup(listCheckbox) {
            // Comprobamos para cada grupo que haya al menos un item seleccionado
            const checkGroup = {};
            var indice = 0;
            this.formGroupsList.forEach(formitems => {
                checkGroup[indice] = 0;
                formitems.formItemsList.forEach(formitem => {
                    Object.entries(listCheckbox).forEach(([key, value]) => {
                        // Comprobamos si esta seleccionado el checkbok en concreto
                        if (formitem.formItem.foitid == key) {
                            if (value == '1') {
								if (formitem.formItem.foitlistid) {
                                	checkGroup[indice] = 1;
								}
                            }
                        }
                    });
                })
                indice++;
            });

            // console.log("length checkGroup: " + Object.keys(checkGroup).length);
            // Comprobamos de forma global todos los grupos
            var complet = 1;
            for (let clave in checkGroup) {
                if (checkGroup.hasOwnProperty(clave)) {
                    const valor = checkGroup[clave];
                    complet = complet * valor;
                    // console.log(clave + ": " + valor);
                }
            }
            console.log("Multiplicado: " + complet);
            return (complet > 0 && completValue > 0) ?  true : false;
        }
        /*
		checkItemsGroup(listCheckbox, listCheckboxValue) {
            // Comprobamos para cada grupo que haya al menos un item seleccionado
            const checkGroup = {};
			const checkGroupValue = {};
            var indice = 0;
            this.formGroupsList.forEach(formitems => {
                checkGroup[indice] = 0;
                checkGroupValue[indice] = 0;
                formitems.formItemsList.forEach(formitem => {
                    Object.entries(listCheckbox).forEach(([key, value]) => {
                        // Comprobamos si esta seleccionado el checkbok en concreto
                        if (formitem.formItem.foitid == key) {
                            if (value == '1') {
								if (formitem.formItem.foitlistid) {
                                	checkGroup[indice] = 1;
								} else if (formitem.formItem.foitattrcommonid != null || formitem.formItem.foitattrevgrid != null ) {
                                	checkGroupValue[indice] = 1;
								}
                            }
                        }
                    });
                })
                indice++;
            });

            // console.log("length checkGroup: " + Object.keys(checkGroup).length);
            // Comprobamos de forma global todos los grupos
            var complet = 1;
            for (let clave in checkGroup) {
                if (checkGroup.hasOwnProperty(clave)) {
                    const valor = checkGroup[clave];
                    complet = complet * valor;
                    // console.log(clave + ": " + valor);
                }
            }
			var completValue = 1;
			for (let clave in checkGroupValue) {
                if (checkGroupValue.hasOwnProperty(clave)) {
                    const valor = checkGroupValue[clave];
                    completValue = completValue * valor;
                    // console.log(clave + ": " + valor);
                }
            }
            console.log("Multiplicado: " + complet);
            console.log("MultiplicadoValue: " + completValue);
            return (complet > 0 && completValue > 0) ?  true : false;
        }
		*/
	},
	computed: {
		formGroupsList: {
			get: function () {
				return this.sortOrderAsc(this.value);
			},
			set: function (newValue) {
				this.$emit('input', newValue);
			}
		}
	}
};
</script>

<style></style>
